(() => {
  const widget = document.querySelector('[data-customer-help]');
  const link = widget?.querySelector('.besneaker-whatsapp-float');
  if (!link) return;
  const desktopLayout = window.matchMedia('(min-width: 750px)');
  const mobile = () => !desktopLayout.matches;
  const key = () => mobile() ? 'bn-whatsapp-position-v1' : 'bn-whatsapp-desktop-position-v3';
  let drag, suppress = false;
  function place(x, y, save = false) {
    const w = widget.offsetWidth || 56, h = widget.offsetHeight || 56;
    let left = Math.max(8, Math.min(innerWidth - w - 8, x));
    let top = Math.max(8, Math.min(innerHeight - h - 12, y));
    const close = document.querySelector('[data-home-shipping]:not([hidden]) [data-shipping-dismiss]')?.getBoundingClientRect();
    if (close && left < close.right + 8 && left + w > close.left - 8 && top < close.bottom + 8 && top + h > close.top - 8) {
      if (close.left - w - 12 >= 8) left = close.left - w - 12;
      else if (close.bottom + h + 24 <= innerHeight) top = close.bottom + 12;
      else top = Math.max(8, close.top - h - 12);
    }
    if (!mobile()) widget.dataset.manualPosition = 'true';
    Object.assign(widget.style, {left: left + 'px', top: top + 'px', right: 'auto', bottom: 'auto', transform: 'none'});
    if (save) try { localStorage.setItem(key(), JSON.stringify({x: left / Math.max(1, innerWidth - w), y: top / Math.max(1, innerHeight - h)})); } catch (_) {}
    document.dispatchEvent(new CustomEvent('bn:whatsapp-position'));
  }
  function restore() {
    try {
      const saved = JSON.parse(localStorage.getItem(key()));
      if (saved && Number.isFinite(saved.x) && Number.isFinite(saved.y)) {
        place(saved.x * (innerWidth - (widget.offsetWidth || 56)), saved.y * (innerHeight - (widget.offsetHeight || 56)));
        return;
      }
    } catch (_) {}
    if (!mobile()) {
      delete widget.dataset.manualPosition;
      ['left', 'top', 'right', 'bottom', 'transform'].forEach(property => widget.style.removeProperty(property));
      document.dispatchEvent(new CustomEvent('bn:whatsapp-position'));
      return;
    }
    const margin = mobile() ? 20 : 28;
    place(innerWidth - (widget.offsetWidth || 56) - margin, innerHeight - (widget.offsetHeight || 56) - (mobile() ? 24 : 28));
  }
  link.addEventListener('dragstart', event => event.preventDefault());
  link.addEventListener('pointerdown', event => {
    if (event.button !== 0) return;
    const rect = widget.getBoundingClientRect();
    drag = {id: event.pointerId, x: event.clientX, y: event.clientY, left: rect.left, top: rect.top, moved: false};
    link.setPointerCapture?.(event.pointerId);
  });
  link.addEventListener('pointermove', event => {
    if (!drag || drag.id !== event.pointerId) return;
    const dx = event.clientX - drag.x, dy = event.clientY - drag.y;
    if (Math.hypot(dx, dy) > 6) { drag.moved = true; widget.classList.add('is-dragging'); }
    if (drag.moved) { event.preventDefault(); place(drag.left + dx, drag.top + dy); }
  });
  const end = event => {
    if (!drag || drag.id !== event.pointerId) return;
    if (drag.moved) {
      const rect = widget.getBoundingClientRect();
      place(rect.left, rect.top, true);
      suppress = true;
      setTimeout(() => { suppress = false; }, 300);
    }
    drag = undefined;
    widget.classList.remove('is-dragging');
  };
  link.addEventListener('pointerup', end);
  link.addEventListener('pointercancel', end);
  link.addEventListener('click', event => { if (suppress) { event.preventDefault(); event.stopImmediatePropagation(); } }, true);
  link.addEventListener('keydown', event => {
    if (event.key === 'Home') {
      event.preventDefault();
      try { localStorage.removeItem(key()); } catch (_) {}
      restore();
      return;
    }
    const delta = {ArrowLeft: [-12, 0], ArrowRight: [12, 0], ArrowUp: [0, -12], ArrowDown: [0, 12]}[event.key];
    if (!delta) return;
    event.preventDefault();
    const rect = widget.getBoundingClientRect();
    place(rect.left + delta[0], rect.top + delta[1], true);
  });
  document.addEventListener('bn:shipping-popup-position', () => {
    if (!mobile() && !widget.dataset.manualPosition) return;
    const rect = widget.getBoundingClientRect();
    place(rect.left, rect.top);
  });
  window.addEventListener('resize', restore);
  window.addEventListener('pageshow', restore);
  window.addEventListener('load', restore);
  desktopLayout.addEventListener('change', restore);
  restore();
})();
